import { Button, Checkbox, Form, Input, message, Modal, Select, Upload } from "antd";
import { useEffect, useState } from "react";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import { formatBytes } from "../../../common/helpers";
import UploadIconRounded from "../../../components/icons/UploadIconRounded";
import FileIconLarge from "../../../components/icons/FileIconLarge";
import { STATUS_COMPLETED, STATUS_PENDING } from "../../../constants/constants";
import { addBrandAdvisory, addPartnerAdvisory, updateBrandAdvisory, updatePartnerAdvisory } from "../../../API/endpoints/Advisory";
import { adversorySubTypeOptions, adversoryTypeOptions, marketOptions } from "../../../constants/dataConstants";
import { GetAllBrands, getAllOrgBrands } from "../../../API/endpoints/Brands";
import { getAllPartners, getAllPartnersUnpaginated } from "../../../API/endpoints/Partner";

interface Props {
    open: boolean;
    editData?: any;
    onCancel: () => void;
    onSuccess: (data: any) => void;
    isPartner: boolean;
    isRequest?: boolean
    orgID: any;
    partnerID?: any
}
const AddEditAdvisoryReportModal = (props: Props) => {
    const { editData, open, onSuccess, isPartner, isRequest, orgID, partnerID } = props;
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const [submitLoading, setSubmitLoading] = useState(false);

    const [fileList, setFileList] = useState<any>([]);

    const [partners, setPartners] = useState<any[]>([]);
    const [brands, setBrands] = useState<any[]>([]);


    useEffect(() => {
        if (orgID) {
            if (isPartner) {
                getAllPartnersUnpaginated().then((res: any) => {
                    setPartners(res?.data || []);
                }).catch((err) => {
                    console.error('failed to fetch brands',);

                })
            } else {
                getAllOrgBrands(orgID).then((res: any) => {
                    setBrands(res?.data?.rows || []);
                }).catch((err) => {
                    console.error('failed to fetch brands',);

                })
            }
        }

    }, [isPartner, orgID])

    useEffect(() => {
        if (editData && Object.keys(editData).length > 0) {

            let file: any[] = [];
            if (editData.path) {
                file = [
                    {
                        uid: `-1`,
                        name: editData?.file_name,
                        url: editData.path,
                    }
                ]
            }

            setFileList(file)
            form?.setFieldsValue({
                partner_id: editData?.partner_id,
                brand_id: editData?.brand_id,
                report_type: editData?.report_type,
                report_sub_type: editData?.report_sub_type,
                markets: editData?.markets,
                description: editData?.description,
                file: file
            })

        }
    }, [editData])



    const handleChange = ({ fileList: newFileList }: any) => {
        const updatedList = newFileList.slice(-1);
        setFileList(updatedList);
        form.setFieldsValue({ file: updatedList });

    };

    const onDeleteFile = () => {
        setFileList([]);
        form.resetFields(["file"])
    }

    const onSubmit = () => {
        form.validateFields().then((values: any) => {
            setSubmitLoading(true);
            if (isPartner || partnerID) {
                const req = new FormData();
                req.append("partner_id", values?.partner_id || partnerID);
                if (values?.file?.[0]?.originFileObj) {
                    req.append("file", values?.file[0]?.originFileObj);
                }
                req.append("report_type", values?.report_type);
                req.append("report_sub_type", values?.report_sub_type);
                req.append("description", values?.description);


                if (values?.markets && values?.markets?.length > 0) {
                    values?.markets?.map((m: string) => {
                        req.append("markets[]", m);
                    })
                }

                if (editData && Object.keys(editData).length > 0) {
                    updatePartnerAdvisory(editData?.id, req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                } else {
                    req.append("status", isRequest ? STATUS_PENDING : STATUS_COMPLETED);
                    addPartnerAdvisory(req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                }
            } else {
                const req = new FormData();
                req.append("brand_id", values?.brand_id);
                if (values?.file?.[0]?.originFileObj) {
                    req.append("file", values?.file[0]?.originFileObj);
                }
                req.append("report_type", values?.report_type);
                req.append("report_sub_type", values?.report_sub_type);
                req.append("description", values?.description || "");


                if (values?.markets && values?.markets?.length > 0) {
                    values?.markets?.map((m: string) => {
                        req.append("markets[]", m);
                    })
                }

                if (editData && Object.keys(editData).length > 0) {
                    updateBrandAdvisory(editData?.id, req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                } else {
                    req.append("status", isRequest ? STATUS_PENDING : STATUS_COMPLETED);
                    addBrandAdvisory(req).then((res: any) => {
                        if (editData?.id) {
                            onSuccess({ id: editData?.id })
                        } else {
                            onSuccess(res?.data)
                        }

                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                }
            }


        })
    }


    const normFile = (e: any) => {

        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    const onCancel = () => {
        props?.onCancel();
        onReset()
    }

    const onReset = () => {
        form.resetFields();
        setFileList([])
    }


    return (
        <Modal
            width={500}
            open={open}
            onCancel={() => onCancel()}
            classNames={{
                content: "!p-0 h-[calc(100vh-40px)] flex flex-col",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0 bg-white",
                body: "!px-[20px] !py-[12px] bg-[#F9FAFB] flex-1 overflow-auto",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            className="h-[calc(100% - 40px)] top-[20px] right-[20px] absolute pb-0"
            title={(
                <p className="m-0 font-[500] text-[14px]">
                    {isRequest ? "Request Report" : "Add Report"}
                </p>
            )}
            okText={"Save"}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
            okButtonProps={{
                loading: submitLoading
            }}
            onOk={() => onSubmit()}
        >
            <Form layout="vertical" requiredMark={false} form={form} scrollToFirstError>
                {contextHolder}
                <div className="grid grid-cols-2 gap-[16px]">
                    {!partnerID ? isPartner ? (
                        <Form.Item
                            className="col-span-2"
                            name="partner_id"
                            label="Partner"
                            rules={[{ required: true, message: "Select partner" }]}
                        >
                            <Select
                                placeholder="Select partner"
                                options={partners}
                                fieldNames={{ label: "name", value: "id" }}
                            />
                        </Form.Item>
                    ) : (
                        <Form.Item
                            className="col-span-2"
                            name="brand_id"
                            label="Brand"
                            rules={[{ required: true, message: "Select brand" }]}
                        >
                            <Select
                                placeholder="Select brand"
                                options={brands}
                                fieldNames={{ label: "brand_name", value: "id" }}
                            />
                        </Form.Item>
                    ) : (
                        <></>
                    )}

                    <Form.Item
                        name="report_type"
                        label="Report Type"
                        rules={[{ required: true, message: "Select partner" }]}
                    >
                        <Select
                            placeholder="Select report type"
                            options={adversoryTypeOptions}
                            value={"Market Intelligence Report"}
                        />
                    </Form.Item>
                    <Form.Item
                        name="report_sub_type"
                        label="Report Sub Type"
                        rules={[{ required: true, message: "Select report sub type" }]}
                    >
                        <Select
                            placeholder="Select report sub type"
                            options={adversorySubTypeOptions}
                            fieldNames={{ label: "text", value: "value" }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="markets"
                        label="Markets"
                        className="col-span-2"
                        rules={[{ required: true, message: "Select markets" }]}
                    >
                        <Checkbox.Group className="grid grid-cols-3">
                            {marketOptions?.map((item) => (
                                <Checkbox key={item?.value} value={item?.value}>{item.label}</Checkbox>
                            ))}
                        </Checkbox.Group>
                    </Form.Item>
                    <Form.Item
                        className="col-span-2"
                        name="description"
                        label="Description"
                        rules={[{ required: true, message: "Enter description" }]}
                    >
                        <Input.TextArea
                            placeholder="Description"
                            rows={3}
                        />
                    </Form.Item>
                    {!isRequest ? (
                        <>
                            <Form.Item
                                className="col-span-2"
                                hidden={fileList.length > 0}
                                name={"file"}
                                valuePropName="fileList"
                                getValueFromEvent={normFile}
                                rules={[{ required: true, message: "File required" }]}
                            >
                                <Upload
                                    listType="picture"
                                    className="w-full upload-form-item"
                                    fileList={fileList}
                                    onChange={handleChange}
                                    beforeUpload={(file) => {
                                        return false
                                    }}
                                    showUploadList={false}
                                >
                                    <div className="flex w-full gap-x-[10px] items-center border border-[#E4E7EC] p-[12px] rounded-[6px] cursor-pointer bg-white hover:!bg-[#F9FAFB]">
                                        <UploadIconRounded />
                                        <div className="flex-1">
                                            <p className="mb-[4px] text-[13px] font-[500]">Upload Document</p>
                                        </div>
                                    </div>
                                </Upload>
                            </Form.Item>
                            {fileList.length > 0 ? (
                                <div className="col-span-2 flex gap-x-[10px] items-center border border-[#E4E7EC] p-[12px] rounded-[6px] bg-white">
                                    <FileIconLarge />
                                    <div className="flex-1">
                                        <p className="mb-[4px] text-[13px] font-[500]">{fileList[0]?.name}</p>
                                        <p className="text-[12px] text-[#475467] m-0">{fileList[0]?.size ? formatBytes(fileList[0]?.size) : ""}</p>
                                    </div>
                                    <Button icon={<DeleteIcon color="#475467" />} type="text" onClick={() => onDeleteFile()} />
                                </div>
                            ) : (
                                <></>
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            </Form>
        </Modal>
    )
}

export default AddEditAdvisoryReportModal